module.exports = __webpack_public_path__ + "static/media/iconSomeQuestions.60905fd0.svg";